/**
 * EmptyFavorites Component
 *
 * Empty state displayed when user has no saved properties.
 * Shows illustration with heart icon and CTA to browse properties.
 */

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function EmptyFavorites() {
  const { t } = useTranslation('favorites');

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      {/* Illustration - Heart icon with gradient circle */}
      <div className="relative mb-6">
        {/* Outer gradient circle */}
        <div className="w-32 h-32 rounded-full bg-[var(--pv-color-primary)]/10 flex items-center justify-center">
          {/* Inner circle */}
          <div className="w-24 h-24 rounded-full bg-[var(--pv-color-primary)]/15 flex items-center justify-center">
            {/* Heart icon */}
            <i className="ri-heart-3-line text-5xl text-[var(--pv-color-primary)]" />
          </div>
        </div>

        {/* Decorative dots */}
        <div className="absolute top-2 right-2 w-2 h-2 rounded-full bg-[var(--pv-color-accent)]/40" />
        <div className="absolute bottom-4 left-0 w-3 h-3 rounded-full bg-[var(--pv-color-primary)]/30" />
        <div className="absolute top-1/2 -right-2 w-1.5 h-1.5 rounded-full bg-[var(--pv-color-primary)]/50" />
      </div>

      {/* Title */}
      <h2 className="text-xl font-semibold text-[var(--pv-color-text)] mb-2">
        {t('favorites.empty.title')}
      </h2>

      {/* Description */}
      <p className="text-sm text-[var(--pv-color-text-muted)] max-w-xs mb-6">
        {t('favorites.empty.description')}
      </p>

      {/* CTA Button */}
      <Link
        to="/search"
        className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-[var(--pv-color-primary)] text-white font-medium hover:bg-[var(--pv-color-primary-dark)] transition-colors shadow-lg shadow-[var(--pv-color-primary)]/20"
      >
        <i className="ri-search-line text-lg" />
        {t('favorites.empty.cta')}
      </Link>
    </div>
  );
}
